import common from "@charmdeer/common";
import { defineStore } from "pinia";

import { getDeployment, getHlDeployment } from "@/api/biz/common";
import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { store } from "@/store";

export const useDeploymentStore = defineStore({
  id: "sys-deployment",
  state: () => ({
    deploymentLoaded: false,
    toggles: null,
    terms: {},
    clients: null,
    layout: {
      hotelList: 'twoColumn',      // 'oneColumn' | 'twoColumn'
      hotelListFilter: 'horizontal', // 'vertical' | 'horizontal'
      hotelRoomList: 'comfortable',  // 'compact' | 'comfortable'
    },
  }),
  actions: {
    async getToggle() {
      const res = await getDeployment();
      const yChannelStore = useYChannelStoreHook();
      let hlRes
      if( yChannelStore.channel === 'hotelux' || yChannelStore.channel === 'hoteluxjp' ){
        hlRes = await getHlDeployment();
      }
      if (res.success || hlRes.success) {
        this.toggles = hlRes?.toggles ? [...res.toggles, ...hlRes?.toggles] : res.toggles;
        this.deploymentLoaded = true;
        this.terms = res?.strategy?.terms;
        this.clients = res?.strategy?.clients;
        common.runtime.toggle.reset(this.toggles);

        let backendLayoutConfig = res?.strategy?.clients?.web?.layout;
        const isToggleActive = this.isActive('Y_WEB_HOTEL_LAYOUT_CUSTOMIZATION')
        if (backendLayoutConfig && isToggleActive) {
           this.layout = { ...this.layout, ...backendLayoutConfig };
        }

      }
    },
    isActive(toggle) {
      const yChannelStore = useYChannelStoreHook();
      return common.runtime.toggle.isActive(toggle, yChannelStore.channel);
    }
  },
});

export function useDeploymentStoreHook() {
  return useDeploymentStore(store);
}
